import { UserOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/manifest-management',
  name: 'ManifestManagement',
  component: Layout,
  meta: { title: 'manifest_management', root: true, auth: AUTH_KEYS.MANIFEST_MANAGEMENT },
  children: [
    {
      path: '/manifest-management',
      name: 'ManifestManagement',
      component: () => import('@/views/Manifest/ManifestManagement.vue'),
      meta: { title: 'Manifest Management', auth: AUTH_KEYS.MANIFEST_MANAGEMENT, isHide: true }
    },
    {
      path: '/manifest-detail',
      name: 'ManifestDetail',
      component: () => import('@/views/Manifest/ManifestDetails.vue'),
      meta: { title: 'manifest_details', auth: AUTH_KEYS.MANIFEST_DETAILS, isHide: true }
    }
  ]
};
